<template>
    <!-- Новий дизайн: «Фільтр інгредієнтів», як у застосунку — інгредієнти розділами, піца підходить,
         коли в ній є все вибране. Вибір застосовується кнопкою «Показати», до того меню не змінюється -->
    <div class="bp-rnd bp-ingf" role="dialog" aria-modal="true" aria-labelledby="bp-ingf-title" @keydown.esc="$emit('close')">
        <div class="bp-rnd__overlay" @click="$emit('close')"></div>
        <div class="bp-ingf__box" ref="box" tabindex="-1">
            <div class="bp-ingf__head">
                <h2 class="bp-ingf__title" id="bp-ingf-title">Фільтр інгредієнтів</h2>
                <button type="button" class="bp-rnd__x" aria-label="Закрити" @click="$emit('close')" v-html="icons.close"></button>
            </div>
            <div class="bp-ingf__body">
                <section v-for="group in groups" :key="group.key" class="bp-ingf__group" :aria-labelledby="'bp-ingf-' + group.key">
                    <h3 class="bp-ingf__gname" :id="'bp-ingf-' + group.key"><span class="bp-ingf__gic" v-html="icons[group.icon]"></span>{{ group.name }}</h3>
                    <div class="bp-ingf__chips">
                        <button v-for="chip in group.chips" :key="chip.term" type="button" class="bp-ingf__chip"
                                :class="{ 'is-on': chip.on }" :disabled="!chip.on && !chip.count"
                                :aria-pressed="chip.on ? 'true' : 'false'" @click="toggle(chip.term)">
                            <span class="bp-ingf__check" v-if="chip.on" v-html="icons.check"></span>{{ chip.label }}<span class="bp-ingf__n" v-if="!chip.on && chip.count">{{ chip.count }}</span>
                        </button>
                    </div>
                </section>
            </div>
            <div class="bp-ingf__foot">
                <button type="button" class="bp-rnd__again" :disabled="!sel.length" @click="sel = []">Скинути</button>
                <button type="button" class="bp-rnd__order" :disabled="!found" @click="$emit('apply', sel)">
                    {{ found ? 'Показати ' + found + ' ' + word(found) : 'Немає такої піци' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import { INGREDIENT_GROUPS, pizzaTerms, hasAll, pizzasWord, termLabel } from '@/ingredientGroups'

export default {
    name: 'BpIngredientFilter',
    props: {
        // Піци після пошуку, але без цього фільтра
        pizzas: { type: Array, required: true },
        value: { type: Array, default: () => [] }
    },
    data() {
        return {
            icons: ICONS,
            sel: this.value.slice()
        }
    },
    computed: {
        terms() {
            return this.pizzas.map(pizza => ({ pizza, terms: pizzaTerms(pizza) }));
        },
        found() {
            return this.terms.filter(row => this.sel.every(term => row.terms.includes(term))).length;
        },
        // Розділи з чипами (лише інгредієнти, що є в піцах); лічильник чипа — скільки піц буде, якщо додати його до вибраного
        groups() {
            const all = {};
            this.terms.forEach(row => row.terms.forEach(term => { all[term] = true; }));
            return INGREDIENT_GROUPS
                .map(group => {
                    const list = group.terms.filter(term => all[term]);
                    return {
                        key: group.key,
                        icon: group.icon,
                        name: group.name,
                        chips: list.map(term => ({
                            term,
                            label: termLabel(term),
                            on: this.sel.includes(term),
                            count: this.pizzas.filter(pizza => hasAll(pizza, this.sel.concat(term))).length
                        }))
                    };
                })
                .filter(group => group.chips.length);
        }
    },
    mounted() {
        document.querySelector('body').style.overflow = 'hidden';
        this.$refs.box.focus();
    },
    beforeDestroy() {
        document.querySelector('body').style.overflow = '';
    },
    methods: {
        toggle(term) {
            const i = this.sel.indexOf(term);
            if (i == -1) this.sel.push(term);
            else this.sel.splice(i, 1);
        },
        word: pizzasWord
    }
}
</script>
